import GetColorListResponse from "@/api/Main/dataSource/api/projects/groups/i-service/model/setting-color/GetColorListResponse";
import GetIconListResponse from "@/api/Main/dataSource/api/projects/groups/i-service/model/setting-icon/GetIconListResponse";
import GetEmployeesListResponse from "@/api/Main/dataSource/api/projects/performers/i-service/model/response/GetEmployeesListResponse";
import { IconColorType, IconType } from "tir-components";
import { UserModel } from "../models";
import OwnedUsersResponse from "@/api/Main/dataSource/api/projects/performers/i-service/model/response/OwnedUsersResponse";

export const mapGetIconsResponse = (response: GetIconListResponse) =>
  response.Items.map<IconType>((item) => {
    return {
      IconId: item.IconId,
      IconUrl: item.IconUrl,
    };
  });

export const mapGetColorsResponse = (response: GetColorListResponse) =>
  response.Items.map<IconColorType>((item) => {
    return {
      ColorId: item.Id,
      Color: item.Color,
    };
  });

export const mapGetEmployeesResponse = (response: GetEmployeesListResponse) =>
  response.Items.map(
    (item) =>
      new UserModel({
        Id: item.UserId,
        FirstName: item.FirstName,
        LastName: item.LastName,
        MiddleName: item.MiddleName,
        Email: item.Email,
        ImageUrl: item.Foto,
      }),
  );

export const mapGetOwnedUsersResponse = (response: OwnedUsersResponse) =>
  response.Items.map(
    (item) =>
      new UserModel({
        Id: item.UserId,
        FirstName: item.FirstName,
        LastName: item.LastName,
        MiddleName: item.MiddleName,
        Email: item.Email,
        ImageUrl: item.Foto,
        AvatarColor: item.AvatarColor,
      }),
  );
